import { Component, Input, OnChanges } from "@angular/core";
import { Router } from "@angular/router";
import { IPredisposition } from "@gloria-public/home/domain/interfaces/home.interface";
import { ServiceRequestOrderStatus } from "@gloria-public/order/domain/interfaces/cart.interface";
import { QRStatus } from "@gloria-public/questionnaire/domain/interfaces/questionnaire-response.interface";

type ProgressView = {
  done: number;
  total: number;
  isComplete: boolean;
};

@Component({
  selector: "app-predisposition",
  templateUrl: "./predisposition.component.html",
  styleUrls: ["./predisposition.component.scss"],
})
export class PredispositionComponent implements OnChanges {
  @Input() predisposition!: IPredisposition;

  public progress: ProgressView = {
    done: 0,
    total: 0,
    isComplete: false,
  };

  constructor(private router: Router) {}

  ngOnChanges(): void {
    if (this.predisposition) {
      this.progress = this.computeProgress(this.predisposition);
    }
  }

  /**
   * Computes completion progress from predisposition data
   * @param p Predisposition data
   * @returns ProgressView containing done, total and completion state
   */
  private computeProgress(p: IPredisposition): ProgressView {
    const total = p.questionnaires.length + p.serviceRequests.length;

    const done =
      p.questionnaires.filter((q) => q.status === QRStatus.COMPLETED).length +
      p.serviceRequests.filter((s) => [ServiceRequestOrderStatus.RESULTS_AVAILABLE].includes(s.status)).length;

    return {
      done,
      total,
      isComplete: done === total && total > 0,
    };
  }

  /**
   * Navigates to a risk detail page
   * @param id Risk identifier
   */
  clickOnRisk(id: string): void {
    this.router.navigate(["/risks", id]);
  }
}
